import { nodeAjax } from './index'

const qryCategory = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + 'ticMall/label/qryshow', option)
}

export {
  qryCategory,
}
